import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { notificationStatus, notificationType } from 'src/app/_enums';
import { DataService } from 'src/app/_helpers';
import { NotificationTemplate, NotificationTemplateUpdateResponse } from 'src/app/_models';
import { CustomerService, TemplateService } from 'src/app/_services';
import { validateNoPreSelect } from 'src/app/invoices/form-validators/partial-payment-validator';
import { checkIcon, frownIcon } from 'src/app/sharedcomp/constans/icons.constans';

@Component({
  selector: 'app-edit-duplicate-template-form',
  templateUrl: './edit-duplicate-template-form.component.html',
  styleUrls: [
    './edit-duplicate-template-form.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../../assets/css/new-form-elements.css'
  ]
})
export class EditDuplicateTemplateFormComponent implements OnInit, OnDestroy {
  tags: any[] = [];

  htmlEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Texto aqui...',
    translate: 'no',
    enableToolbar: true,
    showToolbar: true,

    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  htmlEditorConfigForWhatsapp: AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    minWidth: '100%',
    placeholder: 'Texto aqui...',
    translate: 'no',
    enableToolbar: false,
    showToolbar: true,

    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  private templateId: string;
  formType: 'EDIT' | 'DUPLICATE' | '';
  messageType: string;
  editDuplicateNotificationForm: FormGroup;
  isTypeWhatsApp: boolean;
  notificationType: any[];
  notificationTypeForWhatsapp: any[];
  private customerPublicId: string;

  updateSucess: boolean = false;
  updateError: boolean = false;
  isSubmitButtonDisabled: boolean = false;

  icons: Record<string, { path: string; alt: string }>;

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
    private templateService: TemplateService,
    private dataService: DataService,
    private _notificationType: notificationType,
    private _notificationStatus: notificationStatus
  ) {
    this.initCreateTemplateForm();
    this.icons = this.setIcons();
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == undefined || browserStorage == '') {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = browserStorage;
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }
    this.editDuplicateNotificationForm.get('customer.public_id').setValue(this.customerPublicId);
    this.templateId = this.customerService.templateNotificationId;
    this.formType = this.customerService.templateNotificationFormType;
    this.messageType = this.formType === 'EDIT' ? 'Editar' : 'Duplicar';
    this.getTemplateType();
    this.checkTemplateId();
    this.getTagsApi();
  }

  ngOnDestroy(): void {
    this.customerService.templateNotificationId = '';
    this.customerService.templateNotificationFormType = '';
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.setTemplateStatus(event);
    }
  }

  setTemplateStatus(event: Event) {
    const status = this.editDuplicateNotificationForm.get('status').value;
    this.editDuplicateNotificationForm.get('status').setValue(status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE');
  }

  setIcons() {
    return {
      frown: frownIcon,
      check: checkIcon
    };
  }

  goToList(componentType: 'LIST') {
    this.dataService.displayTemplateSection(componentType);
  }

  initCreateTemplateForm() {
    this.editDuplicateNotificationForm = this.formBuilder.group({
      id: new FormControl(0),
      name: new FormControl("", [Validators.required]),
      header: new FormControl("", [Validators.required]),
      type: new FormControl("Seleccione", [Validators.required, validateNoPreSelect]),
      status: new FormControl("ACTIVE"),
      content: new FormControl("", [Validators.required]),
      customer: this.formBuilder.group({
        public_id: new FormControl('')
      })
    });
  }

  getTemplateType() {
    this.templateService.getTemplateType(this.customerPublicId)
    .pipe(
      takeUntil(this.destroy$),
      tap(data => this.notificationTypeForWhatsapp = data.values.channels.filter(item => item.active === true)),
      map(data => data.values.channels.filter(item => item.active === true && item.id !== 'WHATSAPP')),
      map(filteredItems => filteredItems.map(item => item.id)),
      tap(ids => this.notificationType = ids),
      catchError(error => {
        console.error('Failed while trying to get template type.' + error);
        return of(null);
      })
    )
    .subscribe();
  }

  updateForm(notification: NotificationTemplate) {
    const commonValues = {
      name: notification.name,
      type: notification.type,
      status: notification.status,
      header: notification.header,
      content: notification.content
    };

    if (this.formType === 'EDIT') {
      this.editDuplicateNotificationForm.patchValue({
        ...commonValues,
        id: notification.id
      });
      this.editDuplicateNotificationForm.get('customer').disable();
    } else if (this.formType === 'DUPLICATE') {
      this.editDuplicateNotificationForm.patchValue(commonValues);
      this.editDuplicateNotificationForm.get('id').disable();
    }
  }

  checkTemplateId() {
    if (this.templateId != null && this.templateId !== '') {
      this.dataService.loadSpinner(true);
      this.customerService.getIndNotificationTemplateDetail(this.templateId)
        .pipe(
          takeUntil(this.destroy$),
          tap((notification: NotificationTemplate) => {
            this.isTypeWhatsApp = notification.type == "WHATSAPP" ? true : false;

            if (this.isTypeWhatsApp) {
              this.editDuplicateNotificationForm.disable();
            }

            this.updateForm(notification);
            this.dataService.loadSpinner(false);
          }),
          catchError(error => {
            this.dataService.loadSpinner(false);
            return of(null);
          })
        )
        .subscribe();
    }
  }

  submitNotificationTemplateType(type: 'EDIT' | 'DUPLICATE' | '', value: NotificationTemplate): Observable<NotificationTemplateUpdateResponse | NotificationTemplate> {
    const editTemplate = this.customerService.updateNotificationTemplate(this.templateId, value);
    const createTemplate = this.customerService.createNotificationTemplate(this.customerPublicId, value);
    return type === 'EDIT' ? editTemplate : createTemplate;
  }

  onsubmit({ value }: { value: NotificationTemplate }) {
    this.dataService.loadSpinner(true);
    this.updateError = false;
    this.updateSucess = false;

    const submitType = this.submitNotificationTemplateType(this.formType, value);
    submitType
    .pipe(
      takeUntil(this.destroy$),
      tap(data => {
        this.isSubmitButtonDisabled = true;
        this.updateSucess = true;
        this.dataService.loadSpinner(false);
      }),
      catchError(error => {
        this.dataService.loadSpinner(false);
        this.updateError = true;
        return of(null);
      })
    )
    .subscribe();

  }

  setTemplateType(event) {}

  getTagsApi(){
    this.templateService.getTags().subscribe((data) => {
      this.tags=[
      {label: data[0].name, id: data[0].value},
      {label: data[1].name, id: data[1].value},
      {label: data[2].name, id: data[2].value},
      {label: data[3].name, id: data[3].value},
      {label: data[4].name, id: data[4].value},
      {label: data[5].name, id: data[5].value},
      {label: data[6].name, id: data[6].value},
      {label: data[7].name, id: data[7].value},
      {label: data[8].name, id: data[8].value},
      {label: data[9].name, id: data[9].value},
      {label: data[10].name, id: data[10].value},
      {label: data[11].name, id: data[11].value},
      {label: data[12].name, id: data[12].value},
      {label: data[13].name, id: data[13].value},
      {label: data[14].name, id: data[14].value},
      {label: data[15].name, id: data[15].value},
      {label: data[16].name, id: data[16].value},
      {label: data[17].name, id: data[17].value},
      {label: data[18].name, id: data[18].value},
      {label: data[19].name, id: data[19].value},
      {label: data[20].name, id: data[20].value},
      ]
      }, error => {        
        console.log('Failed while trying get Tags.' + error);
      });
  }

  onOptionSelected($event: Event): void {
    const value: any = $event;
    const value2:string= value
    var inputTemporal = document.createElement("textarea");
    inputTemporal.value = value2;
    document.body.appendChild(inputTemporal);
    inputTemporal.select();
    document.execCommand("copy");
    document.body.removeChild(inputTemporal);
  }

}
